<template>
  <div>
    <section class="round_ended">
      <div class="round_ended__head">
        <div class="round_ended__head__top">
          <h1>{{ isHomePlayerWinner ? getTranslations.home_round_ended_you_won : getTranslations.home_round_ended_you_lost }} {{ currentRoundNumber }} !</h1>
        </div>
        <div class="round_ended__head__bottom">
          <div class="round_ended__head__bottom__player round_ended__head__bottom__player--p1">
            <img :src="playersDetails.homePlayerAvatar" alt="">
            <span>{{ playersDetails.homePlayerUsername }}</span>
            <ul class="player_score player_score left_player">
              <li :class="getHomePlayerAnswersHistory(0)"></li>
              <li :class="getHomePlayerAnswersHistory(1)"></li>
              <li :class="getHomePlayerAnswersHistory(2)"></li>
              <li :class="getHomePlayerAnswersHistory(3)"></li>
            </ul>
          </div>
          <div class="round_ended__head__bottom__player round_ended__head__bottom__player--p2">
            <img :src="playersDetails.awayPlayerAvatar" alt="">
            <span>{{ playersDetails.awayPlayerUsername }}</span>
            <ul class="player_score player_score right_player">
              <li :class="getAwayPlayerAnswersHistory(0)"></li>
              <li :class="getAwayPlayerAnswersHistory(1)"></li>
              <li :class="getAwayPlayerAnswersHistory(2)"></li>
              <li :class="getAwayPlayerAnswersHistory(3)"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="round_ended__center-score">
        <p><span class="p1">{{ isHomePlayerWinner ?  1 : 0}}</span>-<span>{{ isHomePlayerWinner ?  0 : 1 }}</span> </p>
      </div>
      <div class="round_ended__bottom">
        <h2 v-if="isEqualAmountOfCorrectAnswers && isHomePlayerWinner">{{ getTranslations.home_round_ended_you_were_faster }}</h2>
        <h2 v-if="isEqualAmountOfCorrectAnswers && !isHomePlayerWinner">{{ getTranslations.home_round_ended_you_were_slower }}</h2>
        <div v-if="isEqualAmountOfCorrectAnswers" class="donut-chart donut-chart--speed">
          <div class="games-left donut-chart__info">{{ homePlayerTotalAnswerTimeInSec }} ''</div>
          <div id="speed_answering_chart" class="donut-size donut-cont">
            <div class="pie-wrapper">
              <span class="label">
                <span class="smaller">{{ getTranslations.home_round_ended_answer_speed }}</span>
              </span>
              <div class="pie">
                <div class="left-side half-circle"></div>
                <div class="right-side half-circle"></div>
              </div>
              <div class="shadow"></div>
            </div>
          </div>
          <div class="games-played donut-chart__info">{{ awayPlayerTotalAnswerTimeInSec }} ''</div>
        </div>
      </div>
    </section>
    <component :is="currentModal"></component>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import { Howl } from 'howler';
import { pieChartAnimation } from '@/common/jQuery';
import PostGame from '@/components/visitor/freeTrial/modals/PostGameFreePlay';


export default {
  name: 'roundEndedFreePlay',
  data() {
    return {
      isHomePlayerWinner: false,
      currentModal: null,
      showedModal: false,
      userLevel: 0,
      bonusPoints: 0,
      gamesEarned: 0,
      gameWonSound: new Howl({
        src: ['static/sounds/GameWin.ogg', 'static/sounds/GameWin.mp3'],
      }),
      gameLostSound: new Howl({
        src: ['static/sounds/LoseGame.ogg', 'static/sounds/LoseGame.mp3'],
      }),
    };
  },
  created() {
    this.isHomePlayerWinner = this.gameWinnerMSISDN === 'trial user';
    if (this.gameWinnerMSISDN === '') {
      this.isHomePlayerWinner = (this.awayPlayerRoundAnswerTime > this.homePlayerRoundAnswerTime);
      if (this.isHomePlayerWinner) this.setGameWinner({ gameWinnerMSISDN: 'trial user', gameWinnerUsername: 'trial user' });
      else this.setGameWinner({ gameWinnerMSISDN: 'bot', gameWinnerUsername: 'bot' });
    }
  },
  mounted() {
    console.log('in RoundEnded free play mounted hook:');
    if (this.isEqualAmountOfCorrectAnswers) {
      setTimeout(() => {
        pieChartAnimation('#speed_answering_chart', this.getAnswerTimeRatio());
      }, 100);
    }
    setTimeout(() => {
      // wait 5 secs and show post game modal
      this.currentModal = PostGame;
      console.log('showing post game modal...');
      this.showHideModal();
    }, 5000);
  },
  methods: {
    ...mapMutations('game', [
      'increaseCurrentRoundNumberbyOne',
      'setGameWinner',
    ]),
    ...mapMutations('profile', [
      'setShowmodalForLevelUp',
    ]),
    showHideModal() {
      this.$nextTick(() => {
        // eslint-disable-next-line
        $('.modal,.modal-overlay').fadeIn(200);
        if (this.soundsOn) {
          if (this.isHomePlayerWinner) {
            this.gameWonSound.play();
          } else {
            this.gameLostSound.play();
          }
        }
        /* eslint-disable */
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
            console.log('user has not leveled up, going to home page');
            this.currentModal = null;
            this.$router.push('/');
        });
      });
    },
    getHomePlayerAnswersHistory(answerIndex) {
      const homePlayerAnswersHistory = this.homePlayerCorrectAnswersCSSClasses[answerIndex];
      return homePlayerAnswersHistory !== undefined ? homePlayerAnswersHistory : '';
    },
    getAwayPlayerAnswersHistory(answerIndex) {
      const awayPlayerAnswersHistory = this.awayPlayerCorrectAnswersCSSClasses[answerIndex];
      return awayPlayerAnswersHistory !== undefined ? awayPlayerAnswersHistory : '';
    },
    getAnswerTimeRatio() {
      return (this.awayPlayerRoundAnswerTime / (this.homePlayerRoundAnswerTime + this.awayPlayerRoundAnswerTime)) * 100;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'soundsOn',
      'postGameSettings',
    ]),
    ...mapState('game', [
      'playersDetails',
      'currentRoundNumber',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameFinished',
      'homePlayerCorrectAnswersCSSClasses',
      'homePlayerRoundAnswerTime',
      'awayPlayerCorrectAnswersCSSClasses',
      'awayPlayerRoundAnswerTime',
      'gameWinnerMSISDN',
    ]),
    ...mapGetters('game', [
      'isCurrentRoundWinner',
      'isEqualAmountOfCorrectAnswers',
      'isHomePlayer',
      'isGameWinner',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    homePlayerTotalAnswerTimeInSec() {
      return (this.homePlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
    awayPlayerTotalAnswerTimeInSec() {
      return (this.awayPlayerRoundAnswerTime / 1000.0).toFixed(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/RoundEndedFreePlay.vue